import { useSessionState } from "./useSessionState";

const SORT_COLUMN_KEY = "initiativeSort.column";
const SORT_DIR_KEY = "initiativeSort.dir";

export function useInitiativeSort() {
  const [sortColumn, setSortColumn] = useSessionState(SORT_COLUMN_KEY, null);
  const [sortDir, setSortDir] = useSessionState(SORT_DIR_KEY, "asc");
  return { sortColumn, setSortColumn, sortDir, setSortDir };
}
